import * as React from "react";
import { Tooltip } from "antd";
import { useLang } from "../../hooks/useLang";
import { HomeOutlined } from "@ant-design/icons";
import { BreadcrumbItem } from "./BreadcrumbItem";
import { SECURITY_UI_URL } from "../../constants/config.constant";

interface BreadcrumbProps {
    children?: React.ReactNode,
    [key: string]: any,
}

interface BreadcrumbInterface extends React.FC<BreadcrumbProps> {
    Item: typeof BreadcrumbItem;
}

const Breadcrumb: BreadcrumbInterface = (props) => {
    const { t, getLangUrl, lang } = useLang();
    const { children } = props;
    return (
        <>
            <div id="breadcrumb" className="breadcrumb px-3 py-1">
                <span className="me-2 text-uppercase text-muted">{t('You are here')}:</span>
                <nav className="breadcrumb-nav d-inline-block" aria-label="Breadcrumb">
                    <ol className="ps-0 mb-0">
                        <li>
                            <a rel="home" className="breadcrumb-link" href={getLangUrl(lang, '/', SECURITY_UI_URL, true)}>
                                <Tooltip title={t('Home')} placement="bottom" >
                                    <HomeOutlined />
                                    <span className="visually-hidden">{t('Home')}</span>
                                </Tooltip>
                            </a>
                        </li>
                        {children}
                    </ol>
                </nav>
            </div>
        </>
    );
}

Breadcrumb.Item = BreadcrumbItem;
Breadcrumb.displayName = 'Breadcrumb'
export default Breadcrumb;
